/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlListRequest {
    getFixupPrototypeFunction() { return ComplianceControlListRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlListRequest>): ComplianceControlListRequest {
        let obj = Object.assign(new ComplianceControlListRequest(), model);
        ComplianceControlListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlListRequest>): ComplianceControlListRequest {
        if (!model) return null;
        return ComplianceControlListRequest.newInstance(<ComplianceControlListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlListRequest) {
        if (!obj) return;

        models.ComplianceControlListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlListRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceControlListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ComplianceControlFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ComplianceControlSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ComplianceControlSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ComplianceControlFilter;

}
